export type TopicsMode = 'default' | 'bips';
export const CONFIG_TYPE = { default: 'DefaultBrands', bips: 'BIPSCalculation' } as const;

export interface MetricOption {
  Name: string;
  responseCode: string;
  isActive: boolean;
}

export interface Level2Config {
  Parent: string;
  MetricOptions: MetricOption[];
}

export interface EntryPointConfig {
  Level1: string | null;
  Level2: Level2Config[];
  variableCode: string | null;
}

export interface CrossTabConfiguration {
  EntryPoint1: EntryPointConfig | null;
  EntryPoint2: EntryPointConfig | null;
  EntryPoint3: EntryPointConfig | null;
  clientName: string | null;
  mandatory_variable_mapping: any[] | null;
  dimension: any[] | null;
  studyName: string | null;
  isMandatoryLoadClicked: boolean;
  snapshotType: string;
}

export interface TopicsRow {
  rowId: string;
  selected: boolean;
  snapshotType: string;
  sectionName: string;
  subSectionName: string[];
  entryPoint1: string[];
  entryPoint2: string[];
  entryPoint3: string[];
  brandList: string[];
  dimension1: string;
  dimension2: string;
  dimension3: string;
}